const env = import.meta.env as Record<string, string | boolean | undefined>;

const getEnvVar = (key: string, required = true): string => {
  const rawValue = env[key];
  const value = typeof rawValue === 'string' ? rawValue : '';

  if (required && !value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  return value;
};

export const paymentConfig = {
  paystack: {
    publicKey: getEnvVar('VITE_PAYSTACK_PUBLIC_KEY'),
  },
} as const;

export type PaymentProvider = keyof typeof paymentConfig;
